import PropTypes from 'prop-types';
import { ApolloError } from 'apollo-client';

export const occupancyShape = PropTypes.shape({
  overBookingLimit: PropTypes.number,
  roomTypeCode: PropTypes.string,
  soldDeductible: PropTypes.number,
  soldNonDeductible: PropTypes.number,
  totalAvailableRooms: PropTypes.number,
  totalRooms: PropTypes.number
});

export const restrictionShape = PropTypes.shape({
  numberOfDays: PropTypes.number,
  rateCode: PropTypes.string,
  restrictionType: PropTypes.string,
  roomType: PropTypes.string
});

export const roomRateShape = PropTypes.shape({
  ratePlanCode: PropTypes.string,
  roomTypeCode: PropTypes.string,
  total: PropTypes.shape({
    amount: PropTypes.number,
    currencyCode: PropTypes.string
  })
});

export const hotelCalendarDayShape = PropTypes.shape({
  date: PropTypes.string,
  occupancy: PropTypes.arrayOf(occupancyShape),
  restrictions: PropTypes.arrayOf(restrictionShape),
  roomRates: PropTypes.arrayOf(roomRateShape)
});

export const patronRewardShape = PropTypes.shape({
  earnAmount: PropTypes.number,
  earnOverDays: PropTypes.number,
  earnType: PropTypes.string,
  endDate: PropTypes.string,
  isEarnRequired: PropTypes.string,
  maxPrizesPerPeriod: PropTypes.number,
  prizeCode: PropTypes.string,
  prizeName: PropTypes.string,
  prizeType: PropTypes.string,
  promoType: PropTypes.string,
  startDate: PropTypes.string,
  redeemed: PropTypes.number
});

export const pastPatronRewardShape = PropTypes.shape({
  endDate: PropTypes.string,
  endDateUTC: PropTypes.string,
  isNewOffer: PropTypes.bool,
  isSoftOffer: PropTypes.bool,
  maxPrizesPerPeriod: PropTypes.number,
  prizeCode: PropTypes.string,
  prizeName: PropTypes.string,
  prizeType: PropTypes.string,
  startDate: PropTypes.string,
  startDateUTC: PropTypes.string,
  redeemed: PropTypes.number
});

export const pastUsedOfferShape = PropTypes.shape({
  description: PropTypes.string,
  endDate: PropTypes.object,
  endDateDisplay: PropTypes.string,
  getStatus: PropTypes.func,
  getTimeClass: PropTypes.func,
  isAvailable: PropTypes.func,
  isExpired: PropTypes.func,
  isNew: PropTypes.bool,
  isRedeemed: PropTypes.func,
  isSoftOffer: PropTypes.bool,
  name: PropTypes.string,
  quantity: PropTypes.number,
  redeemed: PropTypes.number,
  rewardId: PropTypes.string,
  showRedeemedBtn: PropTypes.func,
  startDate: PropTypes.object,
  startDateDisplay: PropTypes.string,
  type: PropTypes.string
});

export const hotelOfferShape = PropTypes.shape({
  numberOfNights: PropTypes.number,
  bookingStartDate: PropTypes.string,
  bookingEndDate: PropTypes.string,
  name: PropTypes.string,
  patronReward: patronRewardShape
});

export const errorShape = PropTypes.oneOfType([
  PropTypes.instanceOf(Error),
  PropTypes.instanceOf(ApolloError)
]);

export const reservationShape = PropTypes.shape({
  id: PropTypes.number,
  reservationId: PropTypes.number,
  hotelCode: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  total: PropTypes.number,
  profileId: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  accountNumber: PropTypes.string,
  status: PropTypes.string
});

export const submittedAccountShape = PropTypes.shape({
  accountNumber: PropTypes.string,
  accountPin: PropTypes.string
});

export const selectedOfferShape = PropTypes.shape({
  day: PropTypes.string,
  promotionCode: PropTypes.string
});

export const numberOfGuestsShape = PropTypes.shape({
  label: PropTypes.number,
  value: PropTypes.number
});

export const blockShape = PropTypes.shape({
  code: PropTypes.string.isRequired,
  description: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string
});

export const pageShape = PropTypes.shape({
  scrollY: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired
});
